module.exports = __webpack_public_path__ + "img/提交背景图.ad90de20.png";